// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"278":"css/modules","420":"css/user-includes","2588":"css/bs4-admin","2732":"css/includes","8252":"css/app","8273":"css/new-home"}[chunkId] + ".css";
};